import { inject, signal, WritableSignal } from "@angular/core";
import { GetRowIdParams, GridApi, GridOptions, GridReadyEvent } from "ag-grid-enterprise";
import { BudgetTableSubscription } from "./budget-table.subscription";
import { BudgetView } from "../../../models/view/budget/budget.view";
import { TableParent } from "@bitwarden/web-vault/app/models/types/table.types.js";
import { BudgetNameRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/budget-name-renderer/budget-name-renderer.component";
import { BudgetStoreService } from "@bitwarden/web-vault/app/services/store/budget/budget.store.service.js";
import { ChevronCellRenderer } from "@bitwarden/web-vault/app/components/tables/renderers/cell/end-icon-renderer/end-icon-renderer.component";

export class BudgetTable extends BudgetTableSubscription {
  gridApi: GridApi;
  options: GridOptions<BudgetView>;
  budgetToDetail: WritableSignal<BudgetView> = signal<BudgetView>(null);
  selectedRowIndex: number = -1;
  constructor(parent: TableParent) {
    super();

    this.options = {
      popupParent: document.body,
      rowSelection: "single",
      columnDefs: [
        {
          field: "name",
          valueGetter: (params) => {
            const data = params.data;
            return `${data.name}|${data.amount}|${data.interval}`;
          },
          filterValueGetter: (params) => params.data?.name ?? "",
          cellRenderer: BudgetNameRendererComponent,
          filter: "agTextColumnFilter",
          flex: 3,
          minWidth: 150,
          cellStyle: {
            overflow: "visible",
            padding: "8px 0 8px 32px",
            display: "block",
          },
        },
        {
          colId: "rightChevron",
          cellRenderer: ChevronCellRenderer,
          flex: 0.3,
          minWidth: 52,
          maxWidth: 66,
          cellStyle: { overflow: "visible", padding: "8px 16px 8px 0" },
        },
      ],
      context: { parent },
      suppressCellFocus: true,
      suppressContextMenu: true,
      onGridReady: (params: GridReadyEvent) => {
        this.gridApi = params.api;
        this.onRowClicked(this.budgetToDetail());
      },
      getRowId: (params: GetRowIdParams) => String(params.data.id),
      getRowHeight: () => 74,
      getRowStyle: () => ({ overflow: "visible", background: "transparent", border: "none" }),
      getRowClass: (params) => {
        if (params.node.group && params.node.level === 0) {
          return "tw-flex tw-items-end";
        }
        return "";
      },
      onRowClicked: (params) => {
        params.node.setSelected(true, false);
        this.onRowClicked(params.node.data);
      },
    };
  }

  onRowClicked(budget: BudgetView): void {
    if (budget) {
      this.budgetToDetail.set(budget);
      this.budgetStoreService.selectBudget(budget.id);
    }
  }

  clearSelection() {
    this.budgetToDetail.set(null);
  }
}
